import { render, staticRenderFns } from "./UserDocumentControl.vue?vue&type=template&id=9bd2121c&"
import script from "./UserDocumentControl.vue?vue&type=script&lang=js&"
export * from "./UserDocumentControl.vue?vue&type=script&lang=js&"
import style0 from "./UserDocumentControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports